// AdminFrontend/src/unicodex_ui/admin/pages/AdminLoginPage.jsx
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { adminLogin } from "../services/adminAuthApi";
import "../styles/AdminLoginPage.css";

function AdminLoginPage({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const location = useLocation();
  const fromPath = location.state?.from?.pathname || "/applications";

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setSubmitting(true);

    try {
      const normalizedEmail = email.trim().toLowerCase();
      const data = await adminLogin(normalizedEmail, password);
      if (!data || data.ok !== true || !data.token || !data.admin) {
        setError("Invalid response from server.");
        setSubmitting(false);
        return;
      }

      onLoginSuccess(data.token, data.admin, fromPath);
    } catch (err) {
      console.error("[AdminLoginPage] login error:", err);
      const msg =
        err?.response?.data?.error === "invalid_credentials"
          ? "Invalid email or password."
          : "Unable to sign in. Please try again.";
      setError(msg);
      setSubmitting(false);
    }
  }

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-login-page">
        <div className="ucx-login-card">
          <div className="ucx-login-header">
            <h1 className="ucx-login-title">UNI-CODEX Admin</h1>
            <p className="ucx-login-subtitle">
              Secure console for managing prefixes, manufacturers, and identity
              events.
            </p>
          </div>

          {error && <div className="ucx-login-error">{error}</div>}

          <form className="ucx-login-form" onSubmit={handleSubmit}>
            <div className="ucx-login-field">
              <label htmlFor="admin-email">Admin email</label>
              <input
                id="admin-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="joe@doee.com"
                autoFocus
                required
              />
            </div>

            <div className="ucx-login-field">
              <label htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="ucx-btn ucx-btn-primary ucx-login-submit"
              disabled={submitting}
            >
              {submitting ? "Signing in…" : "Sign in to console"}
            </button>

            <p className="ucx-login-footnote">
              This portal is restricted to authorized UNI-CODEX administrators.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}

export default AdminLoginPage;
